import React from 'react';
import { useHistory } from 'react-router-dom';
import Message from './resale/seller/components/message';
import { useTranslation, Trans } from 'react-i18next';
import NeoButton from './neoButton';

export default function TokenErrorPage({tokenError}) {
    const { t } = useTranslation();
    const history = useHistory();

    const backToLogin = React.useCallback(() => {
        let queryParams = window.location.search;
        const arrayParams = queryParams.split('&');
		history.push({
			"search": arrayParams.filter(p => !p.startsWith('?token=')).join('&')
		});
		return window.location.reload();
	}, [history]);

    return (
        <div style={{padding: '20px'}}>
            <div className="wz-neo-layout-header" ><h2><Trans i18nKey="widget.login-error-title"  /></h2></div>
            <div className="wz-neo-layout-description" ><Trans i18nKey="widget.login-error-subtitle"  /></div>
            <Message title={t(`widget.token.message.${tokenError}.title`)} description={t(`widget.token.message.${tokenError}.body`)} type='danger'/>
            <div style={{marginTop: '15px'}}>
                <NeoButton label={t('widget.back-to-login')} onClick={backToLogin}/>
            </div>
        </div>
    )
}